module.exports = __webpack_public_path__ + "img/bg-pc.a59d420a.png";